/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Group } from '@jca/flightpath-components/src/models/CognitoUser';
import Auth from '@aws-amplify/auth';
import { AxiosInstance, AxiosResponse } from 'axios';
import { injectable } from 'inversify';
import { FlightPathAdminServiceInterface } from '@jca/flightpath-components/src/services/FlightPathAdminServiceInterface';
import { FlightPathAxios } from './api';
import { Account } from '@jca/flightpath-components/src/models/Account';

@injectable()
export class FlightPathAdminService implements FlightPathAdminServiceInterface {
  accessToken: string;
  apiService: FlightPathAxios;
  instance: AxiosInstance;
  constructor() {
    this.accessToken = '';
    this.apiService = new FlightPathAxios();
    this.instance = this.apiService.getInstance();
  }

  async updateToken(): Promise<void> {
    this.accessToken = await this.getUpdateToken();
  }
  async getUpdateToken(): Promise<string> {
    return `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`;
  }
  async getUser(email: string): Promise<AxiosResponse<any>> {
    return this.instance.get('/umc/user', {
      params: {
        userName: email
      },
      responseType: 'json'
    });
  }
  async addUser(email: string, group: string): Promise<AxiosResponse<any>> {
    const json = {
      userName: email,
      groupName: group
    };

    return this.instance.post('/umc/user', json);
  }

  async updateUser(userName: string, groups: Group[]): Promise<AxiosResponse<any>> {
    const json = {
      userName: userName,
      Groups: groups
    };

    return this.instance.put('/umc/user', json);
  }

  addAccount(account: Account, ownerEmail: string, group: string): Promise<AxiosResponse<any>> {
    const json = {
      Account: account,
      AccountOwner: {
        userName: ownerEmail,
        groupName: group
      }
    };
    return this.instance.post(`/umc/accounts`, json);
  }
  getAllAccounts(): Promise<AxiosResponse<any>> {
    return this.instance.get(`/umc/accounts`);
  }
  getAccount(accountId: string): Promise<AxiosResponse<any>> {
    return this.instance.get(`/umc/accounts?AccountId=${accountId}`);
  }
  deleteAccount(accountId: string): Promise<AxiosResponse<any>> {
    return this.instance.delete(`/umc/accounts?AccountId=${accountId}`);
  }

  getMachineCredentials(accountId: string): Promise<AxiosResponse<any>> {
    return this.instance.get(`/machinecertificate/credentials/${accountId}/machines`);
  }

  getMachineCredential(accountId: string, machineId: string): Promise<AxiosResponse<any>> {
    return this.instance.get(`/machinecertificate/credentials/${accountId}/machines/${machineId}`);
  }

  AddMachineCredential(accountId: string, machineId: string, machineName: string): Promise<AxiosResponse<any>> {
    return this.instance.post(`/machinecertificate/credentials/${accountId}/machines?machineId=${machineId}&machineName=${machineName}`);
  }

  RecreateMachineCertificate(accountId: string, machineId: string, machineName: string): Promise<AxiosResponse<any>> {
    return this.instance.post(`/machinecertificate/credentials/${accountId}/machines/${machineId}/recreate?machineName=${machineName}`);
  }

  RevokeMachineCertificate(accountId: string, machineId: string): Promise<AxiosResponse<any>> {
    return this.instance.put(`/machinecertificate/credentials/${accountId}/machines/${machineId}/revoke`);
  }
}
